import { ICommentInitAction } from './types';
import { AT_COMMENT_INIT } from './constants';

export const commentInit = (
): ICommentInitAction => ({
    type: AT_COMMENT_INIT,
});
